import React from 'react';
import Component from '@/Component';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import Header from '@/template/components/Header';
// import ContentTopContainer from '@/containers/main/ContentTopContainer';
import AddExceptContainer from '@/containers/main/AddExceptContainer';
import ModifyTimeContainer from '@/containers/main/ModifyTimeContainer';
import ModifyTimeExContainer from '@/containers/main/ModifyTimeExContainer';
import LoaderContainer from '@/containers/common/LoaderContainer';
import Donation from '@/components/common/Donation';
import OutsideModalContainer from '@/containers/outside/OutsideModalContainer';
import BackgroundContainer from '@/containers/common/BackgroundContainer';

import routes from '@/router';

class App extends Component {
  changeThemes(themes) {
    if (themes === 'theme_default') {
      delete localStorage.themes;
    } else {
      localStorage.themes = themes;
    }
    window.location.reload();
  }

  render() {
    return (
      <div className={`${localStorage.themes || ''}`}>
        <Header changeThemes={this.changeThemes} />
        <div className="container">
          {/* {['/', '/outside'].includes(window.location.pathname) ? <ContentTopContainer /> : null} */}
          {routes()}
          <Donation />
        </div>
        <AddExceptContainer />
        <ModifyTimeContainer />
        <ModifyTimeExContainer />
        <LoaderContainer />
        <OutsideModalContainer />
        <ToastContainer
          position="top-center"
          autoClose={1500}
          hideProgressBar
          newestOnTop={false}
          closeOnClick={true}
          rtl={false}
          pauseOnVisibilityChange={false}
          draggable={false}
          pauseOnHover={false}
          />
        <BackgroundContainer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/template/components/App.js